<template>
  <el-button class="w-full btn" :class="{ 'btn--bilingual': !!subtitle }" plain @click="onClicked">
    <span class="flex flex-col items-center justify-center leading-tight">
      <span class="font-medium text-[#303133]">{{ linkTitle }}</span>
      <span v-if="subtitle" class="mt-0.5 text-[12px] font-normal leading-none text-[#2563EB]">{{ subtitle }}</span>
    </span>
  </el-button>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  methods: {
    onClicked() {
      this.$router.push(this.path)
    }
  },
  props: {
    linkTitle: String,
    subtitle: String,
    path: {
      required: true,
      type: String
    }
  }
})
</script>

<style scoped>
.btn {
  margin-block: 0.75rem;
  border: none;
}
.btn--bilingual {
  height: auto !important;
  min-height: 52px;
  padding-block: 8px;
  white-space: normal;
}
.btn:hover {
  background: var(--secondary-hover-bg-color);
  color: var(--secondary-hover-text-color);
}
</style>
